<template>
  <div class="w-full p-8">
    <!--  -->
    <section class="w-full">
      <h1 class="text-xl font-semibold mb-6 p-6 shadow-md bg-white rounde-xl">{{ translate('Meus Curriculos',
        'ucfirst')}}</h1>

      <DataTable :value="curriculumList.data" class="w-full shadow-md">
        <Column header="Id" field="curriculum_id"></Column>
        <Column :header="translate('Tipo', 'ucfirst')" field="curriculum_type"></Column>
        <Column :header="translate('Idioma do Curriculo', 'ucfirst')">
          <template #body="slotProps">
            <span v-for="(language, index) in languages" :key="index">
              <span v-if="language.llangue_id == slotProps.data.clengua_id">
                {{
                  language.llangue_acronyn == 'pt' ? language.pt
                    : language.llangue_acronyn == 'es' ? language.es : language.en

                }}
              </span>
            </span>
          </template>
        </Column>
        <Column :header="translate('Visualizar', 'ucfirst')">
          <template #body="slotProps">
            <RouterLink :to="`/dashboard/${userType}/${slug}/preview/curriculo/${slotProps.data.curriculum_id}`">
              <i class="pi pi-eye mx-auto"></i>
            </RouterLink>
          </template>
        </Column>
      </DataTable>
    </section>

  </div>
</template>
<script setup>
import { ref, computed, onBeforeMount } from "vue";
import { RouterLink } from "vue-router";
import { useStore } from "vuex";
import { useToast } from "primevue/usetoast";
import { showToast } from "@/composables/toast";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import requestHandler from "@/composables/requestHandler";
import { translate } from "@/composables/translate";


// ############ Declaração de Variáveis ############ 


const store = useStore();
let toast = useToast();
let curriculumList = ref([])
let languages = ref([])
let slug = computed(() => store.getters.getUserSlug);
let userType = computed(() => store.getters.getLoggedAs);
// let user_language = computed(() => store.state.user_lang)

// ############ Criação de Métodos/Funções ############


async function getMyCurriculums() {

  const response = await requestHandler.executeRequest(`/api/curriculum/curriculum`, {}, 'get');

  if (!response.success) {
    showToast(toast, translate('Houve um erro ao buscar os seus currículos', 'ucfirst'), 'error');
    return;
  }

  curriculumList.value = response.data

  const languagesResp = await requestHandler.executeRequest(`/api/languages/index`, {}, 'get');

  languages.value = languagesResp.data

}


// ############ Ciclos de Vida/Hooks ############

onBeforeMount(() => {
  getMyCurriculums()
})
</script>